import { render, staticRenderFns } from "./MessageDetails.vue?vue&type=template&id=27bac2ce&scoped=true"
import script from "./MessageDetails.vue?vue&type=script&lang=js"
export * from "./MessageDetails.vue?vue&type=script&lang=js"
import style0 from "./MessageDetails.vue?vue&type=style&index=0&id=27bac2ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bac2ce",
  null
  
)

export default component.exports